import { deriveGroupingCode, typeBehaviour } from 'src/util/orgUnitTypes';
import { withoutBlankContacts } from './contacts';
import { OrgUnitRecord } from './orgUnitModel';

/** Read with the record or added for display; the API knows none of them, so none is posted. */
export const DISPLAY_ONLY_FIELDS = ['ancestors', 'ancestorPath', 'provisioningWarnings', 'organizationalUnitType', 'institutionCode'];

export type OrgUnitPayloadOptions = { isNew: boolean; typeName: string | null; parentCode: string | null };

/**
 * The full-mode save body: the whole record (the backend maps it wholesale onto the unit) minus the
 * display-only fields, with the code each type requires. A contact-info save posts only the
 * contacts and does not come through here.
 */
export function orgUnitPayload(draft: OrgUnitRecord, { isNew, typeName, parentCode }: OrgUnitPayloadOptions): Record<string, unknown> {
  const payload: Record<string, unknown> = { ...draft, orgContactInfo: withoutBlankContacts(draft.orgContactInfo) };
  DISPLAY_ONLY_FIELDS.forEach(field => delete payload[field]);

  const behaviour = typeBehaviour(typeName);
  if (behaviour.code === 'typed') payload.code = String(draft.code ?? '').trim().toUpperCase();
  if (behaviour.code === 'derived') payload.code = deriveGroupingCode(parentCode, draft.name) || (draft.code ?? null);
  // The backend mints an institution's CFIID on create.
  if (behaviour.isInstitution && isNew) delete payload.code;

  return payload;
}
